import styled, { css } from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Title = styled.h3`
	color: ${({ theme }) => theme.colors.text1};
	font-size: 26px;
	font-weight: 700;
	letter-spacing: 0.41px;
	line-height: 32px;
	margin-bottom: 16px;
`;

export const List = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;
